const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.scrollDown();
    },

    scrollDown: function() {
        $('.scroll-down').click(function(){
            const $scroll = $('.target-section');
            const headerHeight = $('#masthead').outerHeight();

            if ($scroll.length) {
                $('html,body').animate({
                    scrollTop: $scroll.offset().top - headerHeight
                }, 500);
            }
        });
	}
}

export default _this;